import { Injectable } from '@angular/core';
import { factory } from 'src/app/config/constants';

@Injectable()
export class ProspectFactoryService {

  constructor() { }

  setProspectId(prospectId: any) {
    sessionStorage.setItem(factory.prospectCustomerId, prospectId);
  }

  getProspectId(): string {
    try {
      return sessionStorage.getItem(factory.prospectCustomerId);
    } catch (e) {
      return '';
    }
  }

  getDataProspect(): string {
    return sessionStorage.getItem(factory.prospectData);
  }

  setDataProspect(prospectData: any) {
    sessionStorage.setItem(factory.prospectData, JSON.stringify(prospectData));
  }

  clearDataProspect() {
    sessionStorage.removeItem(factory.prospectData);
  }

  clearCheckFamilyPlan() {
    sessionStorage.removeItem(factory.checkFamilyPlan);
  }

}
